import styled from "styled-components";

const HomeWrapper = styled.div`
  padding-top: 28px;
  overflow-x: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const HomeSection = styled.div``;

export { HomeWrapper, HomeSection };
